module.exports = __webpack_public_path__ + "static/media/g+.7e239f03.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/g+.svg
// module id = 96
// module chunks = 0